import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import { formatMoney } from "../lib/format";
import { EstimateTable, Stat, MetaGrid } from "../components/EstimateTable";

export function HomeProfile() {
  const { id = "" } = useParams();
  const r = useQuery({ queryKey: ["home", id], queryFn: () => api.homeProfile(Number(id)) });

  if (r.isLoading) return <div className="text-slate-500">Loading...</div>;
  if (!r.data || r.error) return <div className="text-red-600">{(r.error as Error)?.message ?? "Not found"}</div>;

  const h = r.data.home;
  const k = r.data.kpis ?? {};

  return (
    <div className="space-y-6">
      <div className="flex items-baseline justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-liaise-navy">{h.name}</h1>
          <div className="text-sm text-slate-500 mt-1">{h.region ?? "-"} · {h.type_of_service ?? "-"}</div>
        </div>
        <Link to="/all-estimates" className="text-sm text-slate-500 hover:underline">← Back</Link>
      </div>

      <section className="bg-white rounded-2xl border border-slate-200 p-6">
        <MetaGrid items={[
          ["Postcode", h.postcode ?? "-"],
          ["CQC rating", h.cqc_rating ?? "-"],
          ["Service type", h.type_of_service ?? "-"],
          ["PWS at home", String(r.data.pws_count ?? 0)],
          ["Active", h.active ? "Yes" : "No"],
          ["Dataverse ID", h.dataverse_id ?? <span className="text-slate-400">—</span>],
        ]} />
      </section>

      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        <Stat label="Total" value={String(k.total ?? 0)} />
        <Stat label="Drafts" value={String(k.drafts ?? 0)} />
        <Stat label="In review" value={String(k.submitted ?? 0)} highlight={(k.submitted ?? 0) > 0} />
        <Stat label="Approved" value={String(k.approved ?? 0)} />
        <Stat label="Approved £" value={formatMoney(k.approved_value)} />
      </div>

      <section className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <div className="px-6 py-3 border-b border-slate-100 text-sm font-semibold text-liaise-navy">Estimates from this home</div>
        <EstimateTable rows={r.data.estimates ?? []} hide={["home"]} />
      </section>
    </div>
  );
}
